module.exports = __webpack_public_path__ + "static/media/VERSION.117677e1.bin";